/**
 * Product Upsell Handlers
 * Global functions for handling product upsell add to cart and variant selection
 */

// Handle variant selection change
window.handleProductUpsellVariantChange = function (selectElement, formId, skipImage) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const productJsonEl = document.getElementById("ProductJson-" + formId);
  if (!productJsonEl) {
    console.error("Product JSON not found for form:", formId);
    return;
  }

  try {
    const product = JSON.parse(productJsonEl.textContent);
    const selects = form.querySelectorAll('select[name^="options["]');
    const selectedOptions = Array.from(selects).map((s) => s.value);

    // Find matching variant
    const variant = product.variants.find((v) => selectedOptions.every((opt, i) => v.options[i] === opt));

    if (variant) {
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      // Update all price displays (button, toggle, and standalone).
      // Only reformat on a genuine user-driven variant change (selectElement is
      // a real <select>). The automatic init pass (selectElement === null) must
      // leave the server-rendered `| money` price untouched — re-running the JS
      // formatter there can diverge from Liquid (e.g. in the theme editor iframe
      // before Shopify's money formatter is ready), making a correct price
      // suddenly render in a broken format.
      if (selectElement && variant.price != null) {
        const currency = document.querySelector('meta[name="currency"]')?.content || "USD";
        const formattedPrice = formatMoney(variant.price, currency);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        const container = form.closest('[class*="upsell-product-container-"]');
        if (container) {
          // Update only the sale-price element (NOT the wrapper, which also holds
          // the compare-at price) so the compare price is never wiped out.
          container.querySelectorAll('[class*="upsell-sale-price-"], [class*="upsell-toggle-sale-price-"]').forEach(function (el) {
            el.textContent = formattedPrice;
            el.classList.toggle('upsell-on-sale', !!onSale);
          });
          container.querySelectorAll('[class*="upsell-product-price-"]').forEach(function (el) {
            var priceSpan = el.querySelector('span:not([class*="compare-price"])');
            if (priceSpan) {
              priceSpan.textContent = formattedPrice;
            } else {
              el.textContent = formattedPrice;
            }
          });
          container.querySelectorAll('[class*="upsell-compare-price-"], [class*="upsell-toggle-compare-price-"]').forEach(function (el) {
            if (onSale) {
              el.textContent = formatMoney(variant.compare_at_price, currency);
              el.style.display = '';
            } else {
              el.style.display = 'none';
            }
          });
        }
      }
      

      // Update product image to match selected variant
      var img = skipImage ? null : form.querySelector("img");
      if (img) {
        var imgData = variant && variant.featured_image ? variant.featured_image : null;
        if (!imgData && product.featured_image) {
          // Fallback to product featured image
          var fi = product.featured_image;
          imgData = { src: typeof fi === "string" ? fi : fi.src, alt: "" };
        }
        if (imgData && imgData.src) {
          var newSrc = imgData.src.replace(/^\/\//, "https://").split("?")[0] + "?width=150";
          if (newSrc !== img.src) {
            var preload = new Image();
            preload.onload = function () {
              img.src = newSrc;
              if (imgData.alt) img.alt = imgData.alt;
            };
            preload.src = newSrc;
          }
        }
      }
    }

    // Disable unavailable variant option combinations
    selects.forEach(function (currentSelect, idx) {
      Array.from(currentSelect.options).forEach(function (opt) {
        var test = selectedOptions.slice();
        test[idx] = opt.value;
        opt.disabled = !product.variants.some(function (v) {
          return test.every(function (val, i) {
            return v.options[i] === val;
          });
        });
      });
    });
  } catch (error) {
    console.error("Error handling variant change:", error);
  }
};

// Handle add to cart
window.handleProductUpsellAdd = async function (buttonElement, formId) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    return;
  }

  const cartAction = form.dataset.cartAction || "drawer";

  // Disable button and show loading state
  const originalHTML = buttonElement.innerHTML;
  buttonElement.disabled = true;
  buttonElement.classList.add("is-loading");
  buttonElement.innerHTML = '<span class="button-spinner"></span>';

  try {
    if (cartAction === "bulk") {
      if (typeof Elixir_UpsellBulkAdd === 'function') Elixir_UpsellBulkAdd(variantId);
    } else if (cartAction === "redirect") {
      const response = await window.CartApi.add({ items: [{ id: variantId, quantity: 1 }] });
      if (!response.ok) throw new Error("Failed to add to cart");
      const text = await response.text();
      const data = JSON.parse(text);
      if (data.status) throw new Error(data.description || "Failed to add to cart");
      window.location = window.CartApi.routes.cartUrl();
      return;
    } else {
      // Drawer: same request as shop-cart-button-handler (FormData + sections) so we get section HTML and open drawer
      const formData = new FormData(form);
      formData.append("sections", "cart-drawer,cart-icon-bubble");
      formData.append("sections_url", window.location.pathname);

      const response = await window.CartApi.add(formData);
  
      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("Cart add returned non-JSON (likely HTML). Response ok:", response.ok, "Status:", response.status);
        throw new Error("Unable to add to cart. Please try again.");
      }
      if (data.status) {
        console.error("Error adding to cart:", data.description);
        throw new Error(data.description || "Error adding product to cart");
      }
  
      const cartDrawer = document.querySelector("cart-drawer");
      if (form.dataset.cartAction === 'stay' && cartDrawer) {
        cartDrawer.openDrawer = false;
      }
  
      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(data);
      }
  
      if (typeof upsellCarousel === "function") {
        upsellCarousel();
      }
  
      // Show success state (uses the block's "Custom Added Text" when set)
      buttonElement.classList.remove("is-loading");
      buttonElement.classList.add("upsell-add-success");
      buttonElement.textContent = buttonElement.dataset.addedText || "Added";
  
      // Update cart count bubble
      window.CartApi.get()
        .then((cart) => {
          document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
            el.textContent = cart.item_count;
          });
        })
        .catch(() => {});
    }
  } catch (error) {
    console.error("Error adding to cart:", error);

    // Show error state
    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-error");
    buttonElement.innerHTML = "✗ Error";

    // Reset button after 2 seconds
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-error");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  } finally {
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-success");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  }
};

// Handle toggle switch add/remove from cart
window.handleProductUpsellToggle = async function (toggleElement, formId, uniqueId) {
  // Prevent double-calling
  if (toggleElement.dataset.processing === "true") {
    return;
  }
  toggleElement.dataset.processing = "true";

  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    toggleElement.checked = !toggleElement.checked; // Revert
    toggleElement.dataset.processing = "false";
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    toggleElement.checked = !toggleElement.checked; // Revert
    toggleElement.dataset.processing = "false";
    return;
  }

  // Use uniqueId to find the toggle switch more reliably
  const toggleSwitch = document.querySelector(".upsell-toggle-switch-" + uniqueId) || toggleElement.parentElement;
  const isAdding = toggleElement.checked;

  // Show loading state
  if (toggleSwitch) {
    toggleSwitch.classList.add("is-loading");
  }

  try {
    if (isAdding) {
      // Add to cart
      if (form.dataset.cartAction === "bulk") {
        if (typeof Elixir_UpsellBulkAdd === 'function') Elixir_UpsellBulkAdd(variantId);
      } else {
        const response = await window.CartApi.add({ items: [{ id: variantId, quantity: 1 }] });

        if (!response.ok) {
          throw new Error("Failed to add to cart");
        }
      }
    } else {
      if (form.dataset.cartAction === "bulk") {
        // Item was only staged in the form DOM, not yet in the cart — just remove the DOM entry
        if (typeof Elixir_UpsellBulkRemove === 'function') Elixir_UpsellBulkRemove(variantId);
      } else {
        // Remove from cart - first get cart to find the line item
        const cart = await window.CartApi.get();

        // Find the item in cart
        const cartItem = cart.items.find((item) => item.variant_id == variantId);

        if (cartItem) {
          // Calculate new quantity (decrease by 1)
          const newQuantity = cartItem.quantity - 1;

          const response = await window.CartApi.change({
            id: variantId.toString(),
            quantity: newQuantity,
          });

          if (!response.ok) {
            throw new Error("Failed to remove from cart");
          }
        }
      }
    }

    // Success - remove loading state
    if (toggleSwitch) {
      toggleSwitch.classList.remove("is-loading");
    }
    toggleElement.dataset.processing = "false";

    // Bulk mode items are deferred to the main form submit — no cart change happened yet
    if (form.dataset.cartAction !== 'bulk') {
      const data = await window.CartApi.get();

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (form.dataset.cartAction === 'stay') {
          cartDrawer.openDrawer = false;
        }

        await cartDrawer.refreshCartDrawer(data);
      }
    }
  } catch (error) {
    console.error("Error updating cart:", error);

    // Revert toggle state on error
    toggleElement.checked = !toggleElement.checked;
  } finally {
    if (toggleSwitch) {
      toggleSwitch.classList.remove("is-loading");
    }
    toggleElement.dataset.processing = "false";
  }
};

// Event delegation for toggle switches - more reliable than inline handlers
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", function (e) {
    if (e.target.classList.contains("upsell-toggle-input")) {
      const formId = e.target.dataset.formId;
      const uniqueId = e.target.dataset.uniqueId;
      if (formId && uniqueId) {
        handleProductUpsellToggle(e.target, formId, uniqueId);
      }
    }
  });
});
// Thin wrapper around Elixir_FormatMoney (core.js); kept for backwards compatibility.
function formatMoney(cents, currency = "USD") {
  if (typeof window.Elixir_FormatMoney === "function") {
    return window.Elixir_FormatMoney(cents, (typeof Shopify !== "undefined" && Shopify.money_format) || "{{amount}}");
  }
  return new Intl.NumberFormat("en-US", { style: "currency", currency: currency }).format(cents / 100);
}